var bodyElement = document.querySelector("body");
const specsWraps = document.querySelectorAll(".specs-wrap");

specsWraps.forEach((specsWrap) => {
  const blockId = specsWrap.getAttribute("data-block-id");

  const specButton = document.querySelector(`.specs-tab--${blockId}`);
  const specsDetails = document.querySelector(
    `.product-details-wrapper--${blockId}`
  );

  if (!specButton || !specsDetails) {
    console.warn(`Missing elements for block ID ${blockId}`);
    return;
  }

  bodyElement.appendChild(specsDetails);
  const modalContent = specsDetails.querySelector(
    ".product-details-wrapper-inside"
  );

  const closeButton = modalContent.querySelector('.drawer-icon-close');

  const blockEvt = (e) => e.preventDefault();

  specButton.addEventListener("click", (event) => {
    specsDetails.style.visibility = "visible";
    specsDetails.setAttribute("open", "");
    document.body.classList.add("overflow-hidden");
    document.addEventListener("touchstart", blockEvt);
  });

  specsDetails.addEventListener("click", (event) => {
    if (!modalContent.contains(event.target)) {
      closeModal(specsDetails);
    }
  });
  
  if (closeButton) {
    closeButton.addEventListener("click", (event) => {
      closeModal(specsDetails);
    });
  }

  function closeModal(modal) {
    modal.style.visibility = "hidden";
    modal.removeAttribute("open");
    document.body.classList.remove("overflow-hidden");
    document.removeEventListener("touchstart", blockEvt);
  }
});
